<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>财务报表</el-breadcrumb-item>
      <el-breadcrumb-item>销售统计</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="tab">
      <span
        v-for="(v,i) in tab"
        :key="v.id"
        @click="tabTitle(v.value)"
        :class="activeIndex==v.value?'activeTab':''"
      >{{v.label}}</span>
    </div>
    <el-card>
      <div v-if="activeIndex==1">
        <div class="titleSear">
        <el-input placeholder="手机号" v-model="data1.Mobile"></el-input>
          <el-input placeholder="订单号" v-model="data1.OrderNumber"></el-input>
          <span class="datesSpan">日期：</span>
          <el-date-picker
            v-model="valuetime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            clearable
          ></el-date-picker>
          <el-select v-model="data1.distributor_id" filterable placeholder="上级分销商" clearable>
          <el-option
              v-for="item in options"
              :key="item.DistributorID"
              :label="item.Name"
              :value="item.DistributorID"
            ></el-option>
        </el-select>
        <el-select v-model="data1.ScenicID" filterable placeholder="全部景区" clearable>
          <el-option
            v-for="item in option"
            :key="item.ScenicID"
            :label="item.Name"
            :value="item.ScenicID"
          ></el-option>
        </el-select>
          <el-button @click="btn('1')">查询</el-button>
          <el-button @click="erportList('1')">导出</el-button>
        </div>
        <el-table
          :data="tableData"
          v-loading="loading"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width:100%;overflow-y:auto;margin-top: 20px"
        >
         <el-table-column prop="OrderNumber" label="订单号" >
         </el-table-column>
         <el-table-column prop="c_name" label="景区" >
         </el-table-column>
         <el-table-column prop="d_name" label="上级分销商" >
         </el-table-column>
         <el-table-column prop="OrderCode" label="验证码" >
         </el-table-column>
         <el-table-column prop="Mobile" label="手机号码" >
         </el-table-column>
         <el-table-column  label="状态" >
          <template slot-scope="scope">
              <span>{{ scope.row.type=='0'?'未验票':scope.row.type=='1'?'验票':scope.row.type=='2'?'退票':'' }}</span>
          </template>
         </el-table-column>
         <el-table-column prop="CreateTime" label="下单时间" >
         </el-table-column>
         <el-table-column prop="ComsumeFee" label="金额" >
         </el-table-column>
         <el-table-column prop="Count" label="购买数量" >
         </el-table-column>
         <el-table-column prop="UseCount" label="验票数量" >
         </el-table-column>
         <el-table-column prop="CancleCount" label="退票数量" >
         </el-table-column>
        </el-table>
        <div class="pagination">
          <span class="demonstration">共{{data1.total}}条记录，</span>
          <span class="demonstration">当前显示第{{data1.page}}页</span>
          <el-pagination background layout="prev, pager, next" :page-size="data1.page_size" :total="data1.total" :current-page="data1.page"  @current-change="currenchange" ></el-pagination>
        </div>
      </div>
      <div v-if="activeIndex==2">
        <div class="titleSear">
          <span class="datesSpan">日期：</span>
          <el-date-picker
            v-model="valuetime1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            clearable
          ></el-date-picker>
          <el-select v-model="data2.distributor_id" filterable placeholder="上级分销商" clearable>
          <el-option
              v-for="item in options"
              :key="item.DistributorID"
              :label="item.Name"
              :value="item.DistributorID"
            ></el-option>
        </el-select>
        <el-select v-model="data2.ScenicID" filterable placeholder="全部景区" clearable>
          <el-option
            v-for="item in option"
            :key="item.ScenicID"
            :label="item.Name"
            :value="item.ScenicID"
          ></el-option>
        </el-select>
        <el-select v-model="data2.goods_id" filterable placeholder="全部产品" clearable>
          <el-option
            v-for="item in Proption"
            :key="item.ProductID"
            :label="item.ProductName"
            :value="item.ProductID"
          ></el-option>
        </el-select>
          <el-button @click="btn('2')">查询</el-button>
          <el-button @click="erportList('2')">导出</el-button>
        </div>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          v-loading="loading"
          style="width:100%;overflow-y:auto;margin-top: 20px"
        >
         <el-table-column prop="c_name" label="景区名称" >
         </el-table-column>
         <el-table-column prop="d_name" label="上级分销商" >
         </el-table-column>
         <el-table-column prop="OrdernNmber" label="订单号" >
         </el-table-column>
         <el-table-column prop="ProductName" label="产品名称" >
         </el-table-column>
         <el-table-column prop="CountPrice2" label="金额" >
         </el-table-column>
         <el-table-column prop="Use" label="数量" >
         </el-table-column>
         <el-table-column prop="UseTime" label="验票时间" >
         </el-table-column>
        </el-table>
        <div class="pagination">
          <span class="demonstration">共{{data2.total}}条记录，</span>
          <span class="demonstration">当前显示第{{data2.page}}页</span>
          <el-pagination background layout="prev, pager, next" :page-size="data2.page_size" :total="data2.total" :current-page="data2.page"  @current-change="currenchange1" ></el-pagination>
        </div>
      </div>
      <div v-if="activeIndex==3">
        <div class="titleSear">
          <span class="datesSpan">日期：</span>
          <el-date-picker
            v-model="valuetime2"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            clearable
          ></el-date-picker>
          <el-select v-model="data3.distributor_id" filterable placeholder="上级分销商" clearable>
          <el-option
              v-for="item in options"
              :key="item.DistributorID"
              :label="item.Name"
              :value="item.DistributorID"
            ></el-option>
        </el-select>
        <el-select v-model="data3.ScenicID" filterable placeholder="全部景区" clearable>
          <el-option
            v-for="item in option"
            :key="item.ScenicID"
            :label="item.Name"
            :value="item.ScenicID"
          ></el-option>
        </el-select>
        <el-select v-model="data3.goods_id" filterable placeholder="全部产品" clearable>
          <el-option
            v-for="item in Proption"
            :key="item.ProductID"
            :label="item.ProductName"
            :value="item.ProductID"
          ></el-option>
        </el-select>
          <el-button @click="btn('3')">查询</el-button>
          <el-button @click="erportList('3')">导出</el-button>
        </div>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          v-loading="loading"
          :cell-style="cellStyle"
          style="width:100%;overflow-y:auto;margin-top: 20px"
        >
         <el-table-column prop="d_name" label="分销商名称" >
         </el-table-column>
         <el-table-column prop="OrdernNmber" label="订单号" >
         </el-table-column>
         <el-table-column prop="ProductName" label="产品名称" >
         </el-table-column>
         <el-table-column prop="CountPrice2" label="退票金额" >
         </el-table-column>
         <el-table-column prop="Use" label="数量" >
         </el-table-column>
         <el-table-column prop="UseTime" label="退票时间" >
         </el-table-column>
        </el-table>
        <div class="pagination">
          <span class="demonstration">共{{data3.total}}条记录，</span>
          <span class="demonstration">当前显示第{{data3.page}}页</span>
          <el-pagination background layout="prev, pager, next" :page-size="data3.page_size" :total="data3.total" :current-page="data3.page"  @current-change="currenchange2" ></el-pagination>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import {getDistributorTwoSalesOrderList,getParentDistributorList,getDistributorTwoScenicList,
  distributorTwoSalesOrderExport,
  getDistributorTwoGoodsList,
  getDistributorTwoConsumeOrderList,
  getDistributorTwoRefundOrderList,
  distributorTwoConsumeOrderExcel,
  distributorTwoRefundOrderExcel} from '@/request/index.js'
  export default{
    data(){
      return{
        activeIndex:'1',
        tab:[
          {
            value:'1',
            label:'销售记录'
          },
          {
            value:'2',
            label:'消费记录'
          },
          {
            value:'3',
            label:'退票记录'
          }
        ],
        valuetime:'',
        options:[],
        option:[],
        Proption:[],
        data1:{
          token:window.sessionStorage.getItem('Token'),
          Mobile:'',
          OrderNumber:'',
          start_time:'',
          end_time:'',
          ScenicID:'',
          distributor_id:'',
          page:1,
          page_size:10,
          total:0
        },
        tableData:[],
        data2:{
          token:window.sessionStorage.getItem('Token'),
          goods_id:'',
          distributor_id:'',
          ScenicID:'',
          start_time:'',
          end_time:'',
          page_size:10,
          page:1,
          total:0,
        },
        valuetime1:'',
        data3:{
          token:window.sessionStorage.getItem('Token'),
          goods_id:'',
          distributor_id:'',
          ScenicID:'',
          start_time:'',
          end_time:'',
          page_size:10,
          page:1,
          total:0,
        },
        valuetime2:'',
        loading:true
      }
    },
    created(){
      this.getList()
      this.getDistrList()
    },
    methods:{
      // 分销商、景区、产品列表
      getDistrList(){
        let data = {
          token:window.sessionStorage.getItem('Token'),
          page:1,
          page_size:999
        }
        getParentDistributorList(data).then(res=>{
          if(res.data.status=='ok'){
            this.options = res.data.result.data
          }
        })
        getDistributorTwoScenicList(data).then(res=>{
          if(res.data.status=='ok'){
            this.option = res.data.result
          }
        })
        getDistributorTwoGoodsList(data).then(res=>{
          if(res.data.status=='ok'){
            this.Proption = res.data.result.data
          }
        })
      },  
      GetDateStr(AddDayCount) {
        var dd = new Date();
        dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
        var y = dd.getFullYear();
        var m = dd.getMonth()+1;//获取当前月份的日期
        var d = dd.getDate();
        m = (m > 9) ? m : ("0" + m);
        d = (d < 10) ? ("0" + d) : d;
        return y+"-"+m+"-"+d;
      },
      // 查询
      btn(i){
        this.loading = true
        if(i==1){
          this.data1.page = 1
          this.data1.total = 0
          if(this.valuetime){
            this.data1.start_time = this.valuetime[0]  + ' 00:00:00'
            this.data1.end_time = this.valuetime[1] + ' 23:59:59'
          }else{
            this.data1.start_time = ''
            this.data1.end_time = ''
          }
          this.getList()
        }else if(i==2){
          this.data2.page = 1
          this.data2.total = 0
          if(this.valuetime1){
            this.data2.start_time = this.valuetime1[0] + ' 00:00:00'
            this.data2.end_time = this.valuetime1[1] + ' 23:59:59'
          }else{
            this.data2.start_time = ''
            this.data2.end_time = ''
          }
          this.getConsumeList()
        }else if(i==3){
          this.data3.page = 1
          this.data3.total = 0
          if(this.valuetime2){
            this.data3.start_time = this.valuetime2[0]+ ' 00:00:00'
            this.data3.end_time = this.valuetime2[1]+ ' 23:59:59'
          }else{
            this.data3.start_time = ''
            this.data3.end_time = ''
          }
          this.getRefundList()
        }
      },
      erportList(i){
        if(i==1){
          let data = {
            token:window.sessionStorage.getItem('Token'),
            Mobile:this.data1.Mobile,
            OrderNumber:this.data1.OrderNumber,
            start_time:this.valuetime[0]?this.valuetime[0]:'',
            end_time:this.valuetime[1]?this.valuetime[1]:'',
            ScenicID:this.data1.ScenicID,
            distributor_id:this.data1.distributor_id
          }
          distributorTwoSalesOrderExport(this.data1).then(res=>{
            if(res.data.status=='ok'){
              window.location.href = res.data.result;
            }
          })
        }else if(i==2){
          let data = {
            token:window.sessionStorage.getItem('Token'),
            start_time:this.valuetime1[0]?this.valuetime1[0]:'',
            end_time:this.valuetime1[1]?this.valuetime1[1]:'',
            distributor_id:this.data2.distributor_id,
            ScenicID:this.data2.ScenicID,
            goods_id:this.data2.goods_id
          }
          distributorTwoConsumeOrderExcel(data).then(res=>{
            if(res.data.status=='ok'){
              window.location.href = res.data.result;
            }
          })
        }else{
          let data = {
            token:window.sessionStorage.getItem('Token'),
            start_time: this.valuetime2[0]?this.valuetime2[0] + ' 00:00:00':'',
            end_time: this.valuetime2[1]?this.valuetime2[1]  + ' 23:59:59' :'',
            distributor_id:this.data3.distributor_id,
            ScenicID:this.data3.ScenicID,
            goods_id:this.data3.goods_id
          }
          distributorTwoRefundOrderExcel(data).then(res=>{
            if(res.data.status=='ok'){
              window.location.href = res.data.result;
            }
          })
        }
      },
      // 销售分页
      currenchange(e){
        this.loading = true
        this.data1.page = e
        this.getList()
      },
      currenchange1(e){
        this.loading = true
        this.data2.page = e
        this.getConsumeList()
      },
      currenchange2(e){
        this.loading = true
        this.data3.page = e
        this.getRefundList()
      },  
      // 销售列表
      getList(){
        getDistributorTwoSalesOrderList(this.data1).then(res=>{
          if(res.data.status=='ok'){
            this.loading = false
            this.tableData = res.data.result.data
            this.data1.total = res.data.result.total
          }
        })
      },
      // 消费列表
      getConsumeList(){
        getDistributorTwoConsumeOrderList(this.data2).then(res=>{
          if(res.data.status=='ok'){
            this.loading = false
            this.tableData = res.data.result.data
            this.data2.total = res.data.result.total
          }
        })
      },
      // 退款列表
      getRefundList(){
        getDistributorTwoRefundOrderList(this.data3).then(res=>{
          if(res.data.status=='ok'){
            this.loading = false
            this.tableData = res.data.result.data
            this.data3.total = res.data.result.total
          }
        })
      },
      tabTitle(e){
        this.activeIndex = e
        this.loading = true
        if(e=='1'){
          this.tableData = []
          this.getList()
        }else if(e==2){
          this.data2.start_time = this.GetDateStr(-1) + ' 00:00:00'
          this.data2.end_time = this.GetDateStr(0) + ' 23:59:59'
          this.valuetime1 = [this.GetDateStr(-1),this.GetDateStr(0) ]
          this.tableData = []
          this.getConsumeList()
        }else if(e==3){
          this.data3.start_time =  this.GetDateStr(-1) + ' 00:00:00'
          this.data3.end_time = this.GetDateStr(0) + ' 23:59:59'
          this.valuetime2 = [this.GetDateStr(-1),this.GetDateStr(0)]
          this.tableData = []
          this.getRefundList()
        }
      },
      // 表头设置
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        return this.utils.tableHeaderColor({
          row,
          column,
          rowIndex,
          columnIndex
        });
      },
      cellStyle({ row, rowIndex }) {
        return this.utils.cellStyle({
          row,
          rowIndex
        });
      }
    }
  }
</script>
<style lang="less" scoped>
.tab {
  display: flex;
  margin: 20px 0;
  .activeTab {
    background: #246deb;
  }
  span {
    width: 120px;
    height: 40px;
    display: block;
    border-radius: 0px 0px 4px 4px;
    // font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 40px;
    color: #ffffff;
    border: none;
    text-align: center;
    background: #d9d9d9;
    margin-right: 10px;
  }
}

.titleSear {
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .el-input {
    width: 220px;
    height: 40px;
    margin-right: 10px;
    margin-bottom: 1rem;
  }
  .el-select {
    width: 220px;
    margin-right: 10px;
    margin-bottom: 1rem;
  }
  .el-date-editor {
    // width: 250px;
    margin-right: 10px;
    margin-bottom: 1rem;
  }
  .el-button {
    margin-bottom: 1rem;
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    // font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    border: none;
    margin-right: 10px;
  }
  .btnL {
    width: 120px;
    margin-bottom: 1rem;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #246deb;
    color: #ffffff;
  }
}
.datesSpan{
  color: #666;
text-align: right;
font-size: 1.4rem;
margin-bottom: 1rem;
}
.pagination{
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>